import React from 'react';
const stats: [string, string][] = [['6', 'Premium Volumes'], ['675+', 'Pages of Resources'], ['200+', 'Therapeutic Questions'], ['50+', 'Reference Charts'], ['5', 'Bonus Guides Free']];
export function StatsBar() {
  return <section className="w-full bg-surface px-4 py-10 sm:py-12" data-id="element-219" data-mp="1o9kbya9dkre8">
      <div className="mx-auto grid max-w-6xl grid-cols-2 gap-y-8 text-center sm:grid-cols-3 lg:grid-cols-5" data-id="element-220" data-mp="1jd3ntg26ed15">
        {stats.map(([value, label]) => <div key={label} data-id="element-221" data-mp="1ef26azkeelrs">
            <div className="font-serif text-4xl text-amber" data-id="element-222" data-mp="19lza0jo8ky7w">{value}</div>
            <div className="mt-1 text-[10px] font-bold uppercase tracking-[0.13em] text-navy/70 sm:text-xs" data-id="element-223" data-mp="19ko52gj21kf7">
              {label}
            </div>
          </div>)}
      </div>
    </section>;
}